import React from 'react';
import {connect, DispatchProp} from "react-redux";
import {withTranslation} from "react-i18next";
import {RootState} from "../../../reducers";
import StringHelper from "../../services/Common/StringHelper";
import {ConfigApi, MultistoreItemTitleType} from "../../services/Api/types";
import {Link} from "react-router-dom";
import {ReactComponent as LeftIco} from "../../../images/icons/arrow-left.svg";


interface OwnProps {
    config: ConfigApi;
    multistoreConfig?: ConfigApi;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;

function NavbarBackMultistore(props: Props) {
    const addressName = StringHelper.getAddressName(props.config.address);
    const multiStoreItemTitleType = props.multistoreConfig?.type !== "MULTISTORE" ? MultistoreItemTitleType.BOTH : props.multistoreConfig?.layout.multistore_item_title_type ?? MultistoreItemTitleType.BOTH;
    const title = multiStoreItemTitleType === MultistoreItemTitleType.BOTH ? props.config.name : addressName || props.config.name;
    const description = multiStoreItemTitleType === MultistoreItemTitleType.BOTH ? addressName : undefined;

    return (
        <>
            <Link className={"btn btn-back btn-flex btn-back-choose-place btn-choose-place"} to={"/"}>
                <LeftIco/>
                <div className={"multiline"}>
                    <h5>
                        {title}
                    </h5>
                    {description && (
                        <small>
                            {description}
                        </small>
                    )}
                </div>
            </Link>
        </>
    )
}

const mapStateToProps = (state: RootState) => ({})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(NavbarBackMultistore));